import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { LENDER_ID } from "../../../configs/constants";
export const redirectDashboard = async (action, _datastore, { navigateWithClear }) => {
    const user = await SharedPropsService.getUser();
    await navigateWithClear(ROUTE.DASHBOARD, {});
};
export const retryPayment = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.PAYMENT_START, {});
};
export const retryPaymentForeclosure = async (action, _datastore, { network, navigateWithClear }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const lenderId = userContextResponse?.data?.linkedApplications[0]?.lenderAccountId;
    if (lenderId?.toLowerCase() === LENDER_ID.DSP) {
        await navigateWithClear(ROUTE.FORECLOSURE, {});
    }
    else
        await navigateWithClear(ROUTE.OUTSTANDING_DUES, { restartPayment: true });
};
export const retryPaymentForExpiredLoan = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.REPAYMENT, {});
};
export const retryInterestCollectionPayment = async (action, _datastore, { navigateWithClear }) => {
    const user = await SharedPropsService.getUser();
    await navigateWithClear(ROUTE.DASHBOARD, {});
};
export const retryPaymentShortfall = async (action, _datastore, { network, navigate }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const response = await network.get(`${api.getShortfallDetails}/${userContextResponse.data.linkedCredits[0].creditId}`, {
        headers: await getAppHeader(),
    });
    const lenderId = userContextResponse?.data?.linkedApplications[0]?.lenderAccountId;
    const shortfallDetails = response?.data;
    if (lenderId?.toLowerCase() === LENDER_ID.DSP) {
        await navigate(ROUTE.SHORTFALL_REPAY_SCREEN, { shortfallDetails, isFromDsp: true });
    }
    else
        await navigate(ROUTE.SHORTFALL_REPAY_SCREEN, { shortfallDetails });
};
